import { render, staticRenderFns } from "./InpatientReviewDemographics.vue?vue&type=template&id=0c4f5447&"
import script from "./InpatientReviewDemographics.vue?vue&type=script&lang=js&"
export * from "./InpatientReviewDemographics.vue?vue&type=script&lang=js&"
import style0 from "./InpatientReviewDemographics.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports